import { useCallback } from 'react'
import { Handle, Position } from '@xyflow/react'
import armLogo from '@/assets/carTank.png'

function TankNode({ data, isConnectable }) {
  const onChange = useCallback((evt) => {}, [])

  return (
    <div className="custom-node-robots robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div></div>
          <div className="text-center">
            <img src={armLogo} alt="Tank Logo" className="custom-node-robots-logo" />
          </div>
          <div className="text-center">
            <b>Tank</b>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} />
    </div>
  )
}

export default TankNode
